exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".points-tab-bar[data-v-8bc0f11a]{padding:20px}.points-tab-bar .table-header[data-v-8bc0f11a]{margin-bottom:16px;text-align:left}.points-tab-bar .table-header .el-button[data-v-8bc0f11a]{padding:10px 20px}.points-tab-bar .action-buttons[data-v-8bc0f11a]{margin-top:24px;text-align:center}.points-tab-bar .action-buttons .el-button[data-v-8bc0f11a]{margin:0 10px;padding:10px 30px}", ""]);

// exports
